import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  roleId: string;
};

export const deleteRole = async (scope: RequestScope, { roleId }: RequestParams, options: WriteRequestOptions): Promise<EndpointResponse<any>> => {
  try {
    const response = await scopedApi(scope).delete<EndpointResponse<any>>(`/organization/role/${roleId}`, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
